import React from 'react';
import {Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '../context/AuthContext';
import { LeftSide, RightSide, Navbar } from '../components';

const RootLayout = () => {
  const { isAuthenticated, isLoading, authUser } = useUserContext();
  
  if(isLoading) return null;

  if(!isAuthenticated) return <Navigate to="/auth" replace />

  return (
    <div className="relative md:flex flex min-h-screen bg-[#f7f8fc]">
      <div className="flex flex-1 w-full flex-col">
        <Navbar user={authUser} />
        <div className="flex w-full justify-between">
          <LeftSide user={authUser} />    
          <main className="min-w-0 flex-1">
            <Outlet user={authUser} />
          </main>     
          <RightSide />     
        </div> 
      </div>
    </div>
  );
};

export default RootLayout;